import React, { useEffect, useState, useRef, useMemo } from "react";
import { useParams } from "react-router-dom";
import './Detail.css'
import Modal from 'react-responsive-modal';
import ModalCart from 'react-modal';
import 'react-responsive-modal/styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faShoppingCart, faExternalLinkAlt, faStar, faTrash, faHeart } from '@fortawesome/free-solid-svg-icons';
import whatsappIcon from '../../images/wpp.png';
import { Link as Anchor, useNavigate, useLocation } from "react-router-dom";
import storage from '../storage';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DetailLoading from "../DetailLoading/DetailLoading";
import Swal from 'sweetalert2';
import moneda from '../moneda';
import baseURL from '../url';
import { useData } from '../DataContext';
import { usePlan } from '../PlanContext';
import { useHorario } from '../HorarioContext';
import { ruta } from '../paths';

export default function Detail() {
    const navigate = useNavigate();
    const swiperRef = useRef(null);
    SwiperCore.use([Navigation, Pagination, Autoplay]);
    const { idProducto } = useParams();
    const { productos, categorias, contacto, loading, cargarProductos } = useData();
    const { isPlus } = usePlan();
    const { abierto } = useHorario();
    const [producto, setProducto] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalImage, setModalImage] = useState("");
    const [cantidad, setCantidad] = useState(1);
    const [favoritos, setFavoritos] = useState([]);
    const items = [producto?.item1, producto?.item2, producto?.item3, producto?.item4, producto?.item5, producto?.item6, producto?.item7, producto?.item8, producto?.item9, producto?.item10]
    // const [selectedItem, setSelectedItem] = useState(items[0] || "");
    const [selectedItemIndex, setSelectedItemIndex] = useState(0);
    const location = useLocation();

    const contactos = useMemo(() => {
        if (Array.isArray(contacto)) {
            return [...contacto].reverse()[0] || {};
        }
        return contacto || {};
    }, [contacto]);

    useEffect(() => {
        cargarFavoritos();
        if (items.length > 0) {
            setSelectedItemIndex(0);
        }

    }, []);
    const handleSelectionChange = (index) => {
        setSelectedItemIndex(index);
    };


    const cargarFavoritos = () => {
        const storedFavoritos = JSON.parse(storage.getItem('favoritos')) || [];
        setFavoritos(storedFavoritos);
    };

    useEffect(() => {
        const product = productos.find((e) => e.idProducto === parseInt(idProducto));
        setProducto(product);
    }, [idProducto, productos]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);




    function handleCompartirClick() {
        if (navigator.share) {
            navigator.share({
                title: document.title,
                text: 'Echa un vistazo a este producto',
                url: window.location.href,
            })
                .then(() => console.log('Contenido compartido correctamente'))
                .catch((error) => console.error('Error al compartir:', error));
        } else {
            console.error('La API de compartir no está disponible en este navegador.');
        }
    }

    const handleWhatsappMessage = async () => {
        if (!isPlus) {
            const phoneNumber = contactos?.telefono;
            if (phoneNumber) {
                window.open(`https://wa.me/${phoneNumber}`, '_blank');
            }
            return;
        }
        if (!abierto) {
            Swal.fire('Local cerrado', 'No se pueden generar pedidos en este momento', 'info');
            return;
        }
        const { value: formValues } = await Swal.fire({
            title: 'Datos para tu pedido',
            html:
                '<input id="swal-nombre" class="swal2-input" placeholder="Tu nombre *">' +
                '<input id="swal-telefono" class="swal2-input" placeholder="Tu teléfono *">' +
                '<input id="swal-email" class="swal2-input" placeholder="Tu email (opcional)">' +
                '<select id="swal-entrega" class="swal2-select" style="margin-top:10px;padding:10px;width:80%;border:1px solid #ccc;border-radius:5px;">' +
                '  <option value="Retiro personalmente">Recoger en tienda</option>' +
                '  <option value="domicilio">Domicilio</option>' +
                '</select>' +
                '<input id="swal-direccion" class="swal2-input" placeholder="Dirección de entrega *" style="margin-top:10px;display:none;">' +
                '<select id="swal-pago" class="swal2-select" style="margin-top:10px;padding:10px;width:80%;border:1px solid #ccc;border-radius:5px;">' +
                '  <option value="">Método de pago *</option>' +
                '  <option value="efectivo">Efectivo</option>' +
                '  <option value="transferencia">Transferencia bancaria</option>' +
                '</select>',
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: 'Enviar pedido',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#25D366',
            didOpen: () => {
                const entregaSelect = document.getElementById('swal-entrega');
                const direccionInput = document.getElementById('swal-direccion');
                entregaSelect.addEventListener('change', () => {
                    direccionInput.style.display = entregaSelect.value === 'domicilio' ? 'block' : 'none';
                    if (entregaSelect.value !== 'domicilio') direccionInput.value = '';
                });
            },
            preConfirm: () => {
                const nombre = document.getElementById('swal-nombre').value.trim();
                const telefono = document.getElementById('swal-telefono').value.trim();
                const email = document.getElementById('swal-email').value.trim();
                const entregaOpt = document.getElementById('swal-entrega').value;
                const direccion = document.getElementById('swal-direccion').value.trim();
                const pago = document.getElementById('swal-pago').value;
                if (!nombre || !telefono) {
                    Swal.showValidationMessage('Nombre y teléfono son obligatorios');
                    return false;
                }
                if (entregaOpt === 'domicilio' && !direccion) {
                    Swal.showValidationMessage('Ingresa tu dirección para domicilio');
                    return false;
                }
                if (!pago) {
                    Swal.showValidationMessage('Selecciona un método de pago');
                    return false;
                }
                return { nombre, telefono, email, entrega: entregaOpt === 'domicilio' ? direccion : 'Retiro personalmente', pago };
            }
        });

        if (!formValues) return;

        const titulo = producto?.titulo;
        const descripcion = producto?.descripcion;
        const precio = Math.round(Number(producto?.precio));
        const precioTotal = precio * cantidad;
        const precioFormateado = String(precioTotal).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        const item = items[selectedItemIndex];
        const categoria = producto?.categoria;

        // Crear pedido en BD
        let pedidoId = null;
        try {
            const productosPedido = JSON.stringify([{
                idProducto: producto.idProducto,
                titulo: titulo,
                precio: producto.precio,
                cantidad: cantidad,
                item: item || '',
                nota: '',
                imagen: producto.imagen1 || producto.imagen2 || producto.imagen3 || producto.imagen4 || ''
            }]);

            const formData = new FormData();
            formData.append('productos', productosPedido);
            formData.append('total', precioTotal);
            formData.append('nombre', formValues.nombre);
            formData.append('email', formValues.email || '');
            formData.append('telefono', formValues.telefono);
            formData.append('entrega', formValues.entrega);
            formData.append('pago', formValues.pago);
            formData.append('nota', '');
            formData.append('codigo', '');
            formData.append('estado', 'Pendiente');

            const response = await fetch(`${baseURL}/pedidoPost.php`, {
                method: 'POST',
                body: formData,
            });
            const data = await response.json();

            if (data.mensaje) {
                toast.success(data.mensaje);
                pedidoId = data.idPedido;
            }
        } catch (error) {
            console.error('Error al crear pedido:', error);
        }

        // Enviar WhatsApp
        const phoneNumber = contactos?.telefono;
        const url = window.location.href;
        const entregaTexto = formValues.entrega === 'Retiro personalmente' ? 'Recoger en tienda' : `Domicilio: ${formValues.entrega}`;
        const pagoTexto = formValues.pago === 'efectivo' ? 'Efectivo' : 'Transferencia bancaria';

        let message = `Hola, quiero comprar el siguiente producto:\n\n`;
        if (pedidoId) message += `📋 *Pedido #${pedidoId}*\n\n`;
        message += `*${titulo}*\n`;
        if (categoria) message += `Categoria: ${categoria}\n`;
        if (descripcion) message += `Descripcion: ${descripcion}\n`;
        if (item) message += `Opcion: ${item}\n`;
        message += `Cantidad: ${cantidad}\n`;
        message += `\n*Precio: ${moneda} ${precioFormateado}*\n`;
        message += `\nNombre: ${formValues.nombre}`;
        message += `\nTelefono: ${formValues.telefono}`;
        message += `\nEntrega: ${entregaTexto}`;
        message += `\nPago: ${pagoTexto}\n`;
        message += `\nEnlace del producto: ${url}\n`;
        message += `\nQuedo atento a la confirmacion. Gracias!`;

        const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
        window.open(whatsappUrl, '_blank');
    };

    const goBack = () => {
        if (location.key !== 'default') {
            navigate(-1);
        } else {
            navigate(ruta('/'));
        }
    };




    const addToCart = (selectedItem) => {
        if (producto) {
            if (producto.stock < 1) {
                toast.error('No hay stock', { autoClose: 400 });
                return;
            }
            const cart = JSON.parse(storage.getItem('cart')) || [];
            const existingItemIndex = cart.findIndex(item =>
                item.idProducto === producto.idProducto
            );
            if (existingItemIndex !== -1) {
                const existingItem = cart[existingItemIndex];
                const updatedSabores = [...existingItem.item, selectedItem];
                const updatedCantidad = existingItem.cantidad + cantidad;
                cart[existingItemIndex] = { ...existingItem, item: updatedSabores, cantidad: updatedCantidad };
            } else {
                cart.push({ idProducto: producto.idProducto, item: [selectedItem], cantidad });
            }
            storage.setItem('cart', JSON.stringify(cart));
            cargarProductos();
            toast.success('Producto agregado', { autoClose: 400 });
            setTimeout(() => {
                window.location.reload();

            }, 600);
        }
    };

    const incrementCantidad = () => {
        setCantidad(cantidad + 1);
    };

    const decrementCantidad = () => {
        if (cantidad > 1) {
            setCantidad(cantidad - 1);
        }
    };


    const agregarAFavoritos = (idProducto) => {
        const favList = [...favoritos];
        const index = favList.indexOf(idProducto);
        if (index === -1) {
            // Si el producto no está en favoritos, lo agregamos
            favList.push(idProducto);
            setFavoritos(favList);
            storage.setItem('favoritos', JSON.stringify(favList));
            console.log('Producto agregado a favoritos');

        } else {
            // Si el producto está en favoritos, lo eliminamos
            favList.splice(index, 1);
            setFavoritos(favList);
            storage.setItem('favoritos', JSON.stringify(favList));
            console.log('Producto eliminado de favoritos');
        }
    };



    if (!producto) {
        return <DetailLoading />;
    }


    return (


        <div className="detail">

            <ToastContainer />
            <div className="deFlexDetail">
                <button className="back" onClick={goBack}> <FontAwesomeIcon icon={faArrowLeft} /> </button>

                <div className="deFLexIcon">
                    <button onClick={() => agregarAFavoritos(producto.idProducto)} className='favoritos-btn'>
                        <FontAwesomeIcon icon={faHeart} style={{ color: favoritos.includes(producto.idProducto) ? 'red' : 'gray' }} />
                    </button>
                    <button className="share" onClick={handleCompartirClick}> <FontAwesomeIcon icon={faExternalLinkAlt} /> </button>
                </div>


            </div>
            <div className="detail-contain">
                <SwiperSlide id={"swiperDetail"} >
                    <Swiper
                        effect={'coverflow'}
                        grabCursor={true}
                        loop={true}
                        slidesPerView={'auto'}
                        coverflowEffect={{ rotate: 0, stretch: 0, depth: 100, modifier: 2.5 }}
                        navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
                        autoplay={{ delay: 3000 }} // Cambia el valor de 'delay' según tus preferencias
                        pagination={{ clickable: true, }}
                        onSwiper={(swiper) => {
                            console.log(swiper);
                            swiperRef.current = swiper;
                        }}

                    >

                        {
                            producto.imagen1 ?
                                (
                                    <SwiperSlide  >
                                        <img
                                            src={producto.imagen1}
                                            alt={producto.titulo}
                                            className="imagen1"
                                            onClick={() => {
                                                setModalImage(producto.imagen1);
                                                setIsModalOpen(true);
                                            }}
                                        />
                                    </SwiperSlide>
                                ) : (
                                    <>
                                    </>
                                )
                        }

                        {
                            producto.imagen2 ?
                                (
                                    <SwiperSlide  >
                                        <img
                                            src={producto.imagen2}
                                            alt={producto.titulo}
                                            className="imagen2"
                                            onClick={() => {
                                                setModalImage(producto.imagen2);
                                                setIsModalOpen(true);
                                            }}
                                        />
                                    </SwiperSlide>
                                ) : (
                                    <>
                                    </>
                                )
                        }
                        {
                            producto.imagen3 ?
                                (
                                    <SwiperSlide  >
                                        <img
                                            src={producto.imagen3}
                                            alt={producto.titulo}
                                            className="img"
                                            onClick={() => {
                                                setModalImage(producto.imagen3);
                                                setIsModalOpen(true);
                                            }}
                                        />
                                    </SwiperSlide>
                                ) : (
                                    <>
                                    </>
                                )
                        }
                        {
                            producto.imagen4 ?
                                (
                                    <SwiperSlide  >
                                        <img
                                            src={producto.imagen4}
                                            alt={producto.titulo}
                                            className="imagen4"
                                            onClick={() => {
                                                setModalImage(producto.imagen4);
                                                setIsModalOpen(true);
                                            }}
                                        />
                                    </SwiperSlide>
                                ) : (
                                    <>
                                    </>
                                )
                        }
                    </Swiper>
                </SwiperSlide>
                <div className="textDetail">
                    <h2 className="title">{producto.titulo}</h2>
                    <hr />
                    <div className="deFLexBuet">
                        {
                            categorias
                                .filter(categoriaFiltrada => categoriaFiltrada.idCategoria === producto.idCategoria)
                                .map(categoriaFiltrada => (
                                    <h4>  <FontAwesomeIcon icon={faStar} />{categoriaFiltrada.categoria}</h4>

                                ))
                        }
                        {producto.stock >= 1 ? (
                            <span className='estado-badge estado-listo'>Stock {producto.stock}</span>
                        ) : (
                            <span className='estado-badge estado-cancelado'>Agotado</span>
                        )}
                    </div>

                    <div className='deFLexPrice'>
                        <h5 className="price">
                            {moneda} {String(producto?.precio)?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}

                        </h5>

                        {
                            (producto?.precioAnterior !== 0 && producto?.precioAnterior !== undefined) && (
                                <h5 className='precioTachadoDetail'> {moneda} {`${producto?.precioAnterior}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                            )
                        }


                    </div>
                    <p>{producto.descripcion}</p>
                    <div className='itemsDetail'>
                        {producto && items.length > 0 && items.map((item, index) => (
                            item && (
                                <label key={index}>
                                    <input
                                        type="radio"
                                        name="talle"
                                        value={item}
                                        checked={selectedItemIndex === index}
                                        onChange={() => handleSelectionChange(index)}
                                    />
                                    {item}
                                </label>
                            )
                        ))}
                    </div>


                    <div className='deFlexCart'>
                        <button onClick={decrementCantidad}>-</button>
                        <span>{cantidad}</span>
                        <button onClick={incrementCantidad}>+</button>
                    </div>
                    <div className='deFlexGoTocart'>
                        {isPlus && (
                            <button onClick={() => addToCart(items[selectedItemIndex])} className='btnAdd'>Agregar  <FontAwesomeIcon icon={faShoppingCart} />  </button>
                        )}
                        <button className="wpp" onClick={handleWhatsappMessage}>
                            WhatsApp
                            <img src={whatsappIcon} alt="whatsappIcon" />
                        </button>
                    </div>
                </div>
            </div>
            <Modal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                center
                classNames={{
                    modal: 'custom-modal',
                }}
            >
                <img src={modalImage} alt={producto.titulo} />
            </Modal>
        </div>

    )
}





